import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  sessionTimeout: null, // Add this field
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetails(state, { payload }) {
      return { ...state, ...payload };
    },
    clearUserDetails(state) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    // Fixed action type to match rootReducer
    builder.addCase('CLEAR_STORE', () => {
      return initialState;
    });
  },
});

export const {
  setUserDetails,
  clearUserDetails,
} = userSlice.actions;

export default userSlice.reducer;
